<template>
  <div>
    <div class="page-header page-header-small content-header">
      <div class="container">
        <h3 class="title">Sträuße und Gestecke</h3>
      </div>
    </div>
    <div class="section section-work-images">
      <div class="container">
        <div class="row">
          <div class="col-md-10 ml-auto mr-auto">
            <img loading="lazy"
              alt="Hochzeit Blumen"
              class="image-container"
              src="img/bouquets/bouquets-1.jpg"
            />
          </div>
        </div>
        <div class="row mt-4">
          <div class="col-md-10 ml-auto mr-auto">
            <img loading="lazy"
              alt="Hochzeit Blumen"
              class="image-container"
              src="img/bouquets/bouquets-2.jpg"
            />
          </div>
        </div>
        <div class="row mt-4">
          <div class="col-md-10 ml-auto mr-auto">
            <img loading="lazy"
              alt="Hochzeit Blumen"
              class="image-container"
              src="img/bouquets/bouquets-3.jpg"
            />
          </div>
        </div>
        <div class="row mt-4">
          <div class="col-md-10 ml-auto mr-auto">
            <img loading="lazy"
              alt="Hochzeit Blumen"
              class="image-container"
              src="img/bouquets/bouquets-4.jpg"
            />
          </div>
        </div>
        <div class="row mt-4">
          <div class="col-md-10 ml-auto mr-auto">
            <img loading="lazy"
              alt="Hochzeit Blumen"
              class="image-container"
              src="img/bouquets/bouquets-5.jpg"
            />
          </div>
        </div>
        <div class="row mt-4">
          <div class="col-md-10 ml-auto mr-auto">
            <img loading="lazy"
              alt="Hochzeit Blumen"
              class="image-container"
              src="img/bouquets/bouquets-6.jpg"
            />
          </div>
        </div>
        <div class="row mt-4">
          <div class="col-md-10 ml-auto mr-auto">
            <img loading="lazy"
              alt="Hochzeit Blumen"
              class="image-container"
              src="img/bouquets/bouquets-7.jpg"
            />
          </div>
        </div>
        <div class="row mt-4">
          <div class="col-md-10 ml-auto mr-auto">
            <img loading="lazy"
              alt="Hochzeit Blumen"
              class="image-container"
              src="img/bouquets/bouquets-8.jpg"
            />
          </div>
        </div>
        <div class="row mt-4">
          <div class="col-md-10 ml-auto mr-auto">
            <img loading="lazy"
              alt="Hochzeit Blumen"
              class="image-container"
              src="img/bouquets/bouquets-9.jpg"
            />
          </div>
        </div>
        <div class="row mt-4">
          <div class="col-md-10 ml-auto mr-auto">
            <img loading="lazy"
              alt="Hochzeit Blumen"
              class="image-container"
              src="img/bouquets/bouquets-10.jpg"
            />
          </div>
        </div>
        <div class="row mt-4">
          <div class="col-md-10 ml-auto mr-auto">
            <img loading="lazy"
              alt="Hochzeit Blumen"
              class="image-container"
              src="img/bouquets/bouquets-11.jpg"
            />
          </div>
        </div>
        <div class="row mt-4">
          <div class="col-md-10 ml-auto mr-auto">
            <img loading="lazy"
              alt="Hochzeit Blumen"
              class="image-container"
              src="img/bouquets/bouquets-12.jpg"
            />
          </div>
        </div>
        <div class="row mt-4">
          <div class="col-md-10 ml-auto mr-auto">
            <img loading="lazy"
              alt="Hochzeit Blumen"
              class="image-container"
              src="img/bouquets/bouquets-13.jpg"
            />
          </div>
        </div>
        <div class="row mt-4">
          <div class="col-md-10 ml-auto mr-auto">
            <img loading="lazy"
              alt="Hochzeit Blumen"
              class="image-container"
              src="img/bouquets/bouquets-14.jpg"
            />
          </div>
        </div>
        <div class="row mt-4">
          <div class="col-md-10 ml-auto mr-auto">
            <img loading="lazy"
              alt="Hochzeit Blumen"
              class="image-container"
              src="img/bouquets/bouquets-15.jpg"
            />
          </div>
        </div>
        <div class="row mt-4">
          <div class="col-md-10 ml-auto mr-auto">
            <img loading="lazy"
              alt="Hochzeit Blumen"
              class="image-container"
              src="img/bouquets/bouquets-16.jpg"
            />
          </div>
        </div>
        <div class="row mt-4">
          <div class="col-md-10 ml-auto mr-auto">
            <img loading="lazy"
              alt="Hochzeit Blumen"
              class="image-container"
              src="img/bouquets/bouquets-17.jpg"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-md-10 ml-auto mr-auto">
            <img loading="lazy"
              alt="Hochzeit Blumen"
              class="image-container"
              src="img/bouquets/bouquets-18.jpg"
            />
          </div>
        </div>
        <div class="row mt-4">
          <div class="col-md-10 ml-auto mr-auto">
            <img loading="lazy"
              alt="Hochzeit Blumen"
              class="image-container"
              src="img/bouquets/bouquets-19.jpg"
            />
          </div>
        </div>
        <div class="row mt-4">
          <div class="col-md-10 ml-auto mr-auto">
            <img loading="lazy"
              alt="Hochzeit Blumen"
              class="image-container"
              src="img/bouquets/bouquets-20.jpg"
            />
          </div>
        </div>
        <div class="row mt-4">
          <div class="col-md-10 ml-auto mr-auto">
            <img loading="lazy"
              alt="Hochzeit Blumen"
              class="image-container"
              src="img/bouquets/bouquets-21.jpg"
            />
          </div>
        </div>
        <div class="row mt-4">
          <div class="col-md-10 ml-auto mr-auto">
            <img loading="lazy"
              alt="Hochzeit Blumen"
              class="image-container"
              src="img/bouquets/bouquets-22.jpg"
            />
          </div>
        </div>
        <div class="row mt-4">
          <div class="col-md-10 ml-auto mr-auto">
            <img loading="lazy"
              alt="Hochzeit Blumen"
              class="image-container"
              src="img/bouquets/bouquets-23.jpg"
            />
          </div>
        </div>
        <div class="row mt-4">
          <div class="col-md-10 ml-auto mr-auto">
            <img loading="lazy"
              alt="Hochzeit Blumen"
              class="image-container"
              src="img/bouquets/bouquets-24.jpg"
            />
          </div>
        </div>
        <div class="row mt-4">
          <div class="col-md-10 ml-auto mr-auto">
            <img loading="lazy"
              alt="Hochzeit Blumen"
              class="image-container"
              src="img/bouquets/bouquets-25.jpg"
            />
          </div>
        </div>
        <div class="row mt-4">
          <div class="col-md-10 ml-auto mr-auto">
            <img loading="lazy"
              alt="Hochzeit Blumen"
              class="image-container"
              src="img/bouquets/bouquets-26.jpg"
            />
          </div>
        </div>
        <div class="row mt-4">
          <div class="col-md-10 ml-auto mr-auto">
            <img loading="lazy"
              alt="Hochzeit Blumen"
              class="image-container"
              src="img/bouquets/bouquets-27.jpg"
            />
          </div>
        </div>
        <div class="row mt-4">
          <div class="col-md-10 ml-auto mr-auto">
            <img loading="lazy"
              alt="Hochzeit Blumen"
              class="image-container"
              src="img/bouquets/bouquets-28.jpg"
            />
          </div>
        </div>
        <div class="row mt-4">
          <div class="col-md-10 ml-auto mr-auto">
            <img loading="lazy"
              alt="Hochzeit Blumen"
              class="image-container"
              src="img/bouquets/bouquets-29.jpg"
            />
          </div>
        </div>
        <div class="row mt-4">
          <div class="col-md-10 ml-auto mr-auto">
            <img loading="lazy"
              alt="Hochzeit Blumen"
              class="image-container"
              src="img/bouquets/bouquets-30.jpg"
            />
          </div>
        </div>
        <div class="row mt-4">
          <div class="col-md-10 ml-auto mr-auto">
            <img loading="lazy"
              alt="Hochzeit Blumen"
              class="image-container"
              src="img/bouquets/bouquets-31.jpg"
            />
          </div>
        </div>
        <div class="row mt-4">
          <div class="col-md-10 ml-auto mr-auto">
            <img loading="lazy"
              alt="Hochzeit Blumen"
              class="image-container"
              src="img/bouquets/bouquets-32.jpg"
            />
          </div>
        </div>
        <div class="row mt-4">
          <div class="col-md-10 ml-auto mr-auto">
            <img loading="lazy"
              alt="Hochzeit Blumen"
              class="image-container"
              src="img/bouquets/bouquets-33.jpg"
            />
          </div>
        </div>
        <div class="row mt-4">
          <div class="col-md-10 ml-auto mr-auto">
            <img loading="lazy"
              alt="Hochzeit Blumen"
              class="image-container"
              src="img/bouquets/bouquets-34.jpg"
            />
          </div>
        </div>
        <div class="row mt-4">
          <div class="col-md-10 ml-auto mr-auto">
            <img loading="lazy"
              alt="Hochzeit Blumen"
              class="image-container"
              src="img/bouquets/bouquets-35.jpg"
            />
          </div>
        </div>
        <div class="row mt-4">
          <div class="col-md-10 ml-auto mr-auto">
            <img loading="lazy"
              alt="Hochzeit Blumen"
              class="image-container"
              src="img/bouquets/bouquets-36.jpg"
            />
          </div>
        </div>
        <div class="row mt-4">
          <div class="col-md-10 ml-auto mr-auto">
            <img loading="lazy"
              alt="Hochzeit Blumen"
              class="image-container"
              src="img/bouquets/bouquets-37.jpg"
            />
          </div>
        </div>
        <div class="row mt-4">
          <div class="col-md-10 ml-auto mr-auto">
            <img loading="lazy"
              alt="Hochzeit Blumen"
              class="image-container"
              src="img/bouquets/bouquets-38.jpg"
            />
          </div>
        </div>
        <div class="row mt-4">
          <div class="col-md-10 ml-auto mr-auto">
            <img loading="lazy"
              alt="Hochzeit Blumen"
              class="image-container"
              src="img/bouquets/bouquets-39.jpg"
            />
          </div>
        </div>
        <div class="row mt-4">
          <div class="col-md-10 ml-auto mr-auto">
            <img loading="lazy"
              alt="Hochzeit Blumen"
              class="image-container"
              src="img/bouquets/bouquets-40.jpg"
            />
          </div>
        </div>
        <div class="row mt-4">
          <div class="col-md-10 ml-auto mr-auto">
            <img loading="lazy"
              alt="Hochzeit Blumen"
              class="image-container"
              src="img/bouquets/bouquets-41.jpg"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Tabs, TabPane } from '@/components';

export default {
  name: 'bouquets',
  bodyClass: 'bouquets-page'
};
</script>
<style scoped>
.list {
  text-align: left;
  margin-left: 50px;
}

@media only screen and (max-width: 800px) {
  .list {
    margin-left: 10px;
  }
}
</style>
